import './UserProfile.css'
import { React } from 'react'
import Navbar from '../components/Navbar';
// import Table from '../components/Table';
import { FaUserCircle } from 'react-icons/fa';
// basic layout of the page:
// profile picture ; user info (name, role, active/inactive, member since)
// previous roles

const UserProfile = (props) => {
    const { user } = props;

    const getDate = (inputDate) => {
        const date = new Date(inputDate);
        const timeZoneOffset = date.getTimezoneOffset() * 60000;
        const newDate = new Date(date.getTime() + timeZoneOffset);
        return newDate.toLocaleDateString();
      };

    return (
        <div>
            <Navbar />
            {Object.keys(user).length !== 0 ?
                <div className="center-box">
                    <div className='body-box'>
                        <h1>User Profile</h1>
                        <div className="info-box">
                            <div className='user-icon'>
                                <FaUserCircle size="170px"/>
                            </div>
                            <div className='user-info'>
                                <p> <b> Name: </b>  {user.firstName}</p>
                                <p> <b>Role: </b> {user.roles[0].name}</p>
                                {/* <p> <b>Status:</b> {infoJson['status']}</p> */}
                                <p> <b>Member Since:</b> {getDate(user.dateCreated)}</p>
                                <button className='edit-button'> Edit info </button>
                            </div> 
                        </div>
                        {/* <div className='user-roles'>
                            <h3>Previous Roles:</h3>
                            <b><u><Table role="Role" period= "Period"/></u></b>
                            {infoJson['roles'].map((a) => {return(
                                <Table role={a['role']} period= {`${a["start"]} - ${a["end"]} `}/>
                            )})}
                        </div> */}
                    </div>
                </div>
            : <h3>Loading ...</h3> }
        </div>
    );
};

export default UserProfile;